export default __webpack_public_path__ + "static/pledge_climate-915606325283df178f08709a9ac4c2ba.webp";